import { Injectable, Pipe, PipeTransform } from "@angular/core";

import { SplitCategory } from "@bitwarden/web-vault/app/models/data/shared/split-category/split-category";
import { CategoryService } from "@bitwarden/web-vault/app/services/DataService/category/category.service";
@Pipe({
  name: "categoryPipe",
})
@Injectable({
  providedIn: "root",
})
export class CategoryPipe implements PipeTransform {
  constructor(private categoryService: CategoryService) {}

  async transform(value: any, method: string, args?: any[]) {
    if (method === "getCategoryName") {
      return this.getCategoryName(value);
    }

    if (method === "getCategoriesNamesList") {
      return this.getCategoriesNamesList(value);
    }

    return value;
  }

  async getCategoryName(id: string): Promise<string> {
    const book = await this.categoryService.get(id);
    return book.name;
  }

  async getCategoriesNamesList(ids: SplitCategory[]): Promise<string> {
    let idsList = "";
    const promises = ids.map(async (value, index) => {
      const category = await this.categoryService.get(value.categoryLink.id);
      if (category) {
        idsList += index === ids.length - 1 ? category.name : category.name + ", ";
      }
    });

    await Promise.all(promises);
    return idsList;
  }
}
